// Commmon props for anchor tags
export const COMMON_LINK_PROPS = {
  TARGET_BLANK: '_blank',
  NO_OPENER: 'noopener noreferrer',
};

export default {
  COMMON_LINK_PROPS,
};
